import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core'

@Component({
  selector: 'vdr-pagination-controls-2',
  templateUrl: './pagination-controls-2.component.html',
  styleUrls: ['./pagination-controls-2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationControls2Component {
  @Input() id?: number
  @Input() currentPage: number
  @Input() itemsPerPage: number
  @Input() totalItems: number
  @Output() pageChange = new EventEmitter<number>()
  @Output() itemsPerPageChange = new EventEmitter<number>()
  protected Math = Math

  getTotalPages(totalItems: number, itemsPerPage: number): number[] {
    const pageCount = Math.ceil(totalItems / itemsPerPage)
    return Array(pageCount)
      .fill(0)
      .map((_, i) => i)
  }

  getVisiblePages(): Array<number | string> {
    const totalPages = this.getTotalPages(
      this.totalItems,
      this.itemsPerPage
    ).length

    if (totalPages <= 10) {
      return Array.from({ length: totalPages }, (_, i) => i + 1)
    }

    const pages: Array<number | string> = []

    // Always show first page
    pages.push(1)

    if (this.currentPage <= 4) {
      // Show first 5 pages, ellipsis, last page
      pages.push(2, 3, 4, 5, '...', totalPages)
    } else if (this.currentPage >= totalPages - 3) {
      // Show first page, ellipsis, last 5 pages
      pages.push(
        '...',
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages
      )
    } else {
      // Show first page, ellipsis, current-2, current-1, current, current+1, current+2, ellipsis, last page
      pages.push(
        '...',
        this.currentPage - 2,
        this.currentPage - 1,
        this.currentPage,
        this.currentPage + 1,
        this.currentPage + 2,
        '...',
        totalPages
      )
    }

    return pages
  }
}
